module.exports = __webpack_public_path__ + "media/images/lb/302-7b7265e71521fa36dbdbc7f6afc3f7ba.svg";